module.exports = __webpack_public_path__ + "img/icon-logout.863f7103.svg";